import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, SaveUnidadFuncionalTipoRelacionDto, SearchUnidadFuncionalTipoRelacionRequest, UnidadFuncionalTipoRelacion } from "../model/index";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})
export class UnidadFuncionalTipoRelacionService extends CrudService<UnidadFuncionalTipoRelacion, number, SaveUnidadFuncionalTipoRelacionDto, SearchUnidadFuncionalTipoRelacionRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'UnidadFuncionalTipoRelacion', sharedFunctions);

  }
}